import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useTranslation } from "react-i18next";

const ScoreBoard = ({ scores }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false); // default = collapsed

  const toggleExpand = () => setIsExpanded((prev) => !prev);

  return (
    <section className="bg-Neutral-30 shadow-sm p-2 rounded-lg overflow-hidden hidden md:block">

      {/* ================= HEADER (ALWAYS VISIBLE) ================= */}
      <div
        onClick={toggleExpand}
        className="
          flex items-center justify-between
          px-3 py-2
          cursor-pointer
          select-none
        "
      >
        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
          <h6 className="text-xl font-bold text-black-90">
          {t("scoreBoard.title")}
          </h6>

          <span className="text-xl bg-Brand-lemon-100 text-black-800 px-2 rounded w-fit">
            {t("updates.newFeature")}
          </span>
        </div>

        {/* Chevron */}
        <div className="text-black-800">
          {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </div>
      </div>

      {/* ================= COLLAPSIBLE BODY ================= */}
      <div
        className={`
          transition-all duration-300 ease-in-out
          ${isExpanded ? "max-h-[500px] opacity-60" : "max-h-0 opacity-0"}
          overflow-hidden
        `}
      >
        <div className="p-3 pointer-events-none select-none">
          {/* Score Chips */}
          <div className="flex flex-wrap items-center gap-2">
            {scores?.map((scoreTitle, index) => (
              <div
                key={index}
                className="
                  flex items-center justify-between
                  h-8
                  p-4
                  rounded-lg
                  border-2 border-black-40
                  text-xl
                  min-w-[140px]"
                >
                <span className="text-gray-600 font-medium whitespace-nowrap">
                  {scoreTitle}
                </span>

                <span className="ml-2 border-2 border-black-100 bg-black-0 rounded-full px-2 text-sm font-bold text-black-90">
                  0000
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default ScoreBoard;
